import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 'aws-enlb-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isTargetInstanceOpen: false,
        isHealthCheckOpen: false,
    },
});

export const isValidISANumber = atom({
    key: 'aws-enlb-isValidISANumber',
    default: false,
});

export const isValidScanNumber = atom({
    key: 'aws-enlb-isValidScanNumber',
    default: false,
});

export const isEnvDetailsLoading = atom({
    key: 'aws-enlb-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 'aws-enlb-orderId',
    default: '',
});

export const isValidOwners = atom({
    key: 'aws-enlb-isValidOwners',
    default: {
        isvalidAppOwner: true,
    },
});

export const sspSubmitOrder = atom({
    key: 'aws-enlb-sspOrder',
    default: {
        // Application Section
        securityScanCompleted: 'no',
        entityDetails: null,
        appProfile: null,
        applicationName: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        hCode: null,
        hCodeDetails: null,
        appUrl: null,
        appOwner: null,
        appOwnerDetails: null,
        dataClassification: null,
        adCertGroup: null,
        appSupportMailId: null,
        landingZoneDetails: null,

        // Resource Section
        availabilityZone: [],
        loadBalancerType: 'external',
        trafficType: 'nlb',
        supportBackendCertificate: null,
        isAlbRequired: null,
        // Yes Scenario
        albNameInternal: null,
        albArn: null,
        instanceId: 'no',
        targets: [],
        targetsDetail: [],
        // No Scenario
        appShortName: null,
        albName: null,
        targetGrpName: null,
        targetGrpNameNlb: null,
        listenerPort: 443,
        listenerProtocol: 'TCP',
        targetType: 'IP',
        targetPort: '443',
        targetProtocol: 'TCP',
        hcProtocol: null,
        hcProtocolDetail: null,
        hcPath: null,
        hcPort: null,
        isNlbRequired: null,
        // Yes Scenario
        nlbNameInternal: null,
        nlbArn: null,
        internalNlbName: null,
        // No Scenario
        nlbName: null,
        // appShortName: null,

        // Track which load balancer was set to "no" first for AppShortName cross-dependency
        albNoFirst: false,
        nlbNoFirst: false,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        isaValidation: null,
        isaValidationMessage: null,
        isaValidationDetails: null,
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'aws-enlb-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'aws-enlb-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'aws-enlb-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 'aws-enlb-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'aws-enlb-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'aws-enlb-isAppShortNameExist',
    default: false,
});

export const isAppUrlValid = atom({
    key: 'aws-enlb-isAppUrlValid',
    default: false,
});

export const isValidappSupportMailId = atom({
    key: 'aws-enlb-isValidappSupportMailId',
    default: false,
});

export const isTargetInstanceFullfilled = atom({
    key: 'aws-enlb-isTargetInstanceFullfilled',
    default: false,
});

export const isHealthCheckFullfilled = atom({
    key: 'aws-enlb-isHealthCheckFullfilled',
    default: false,
});
